import { styled } from "sharedUI/styles";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 40px 0;

    & > div.buy-template-dropdown-container {
        width: 100%;

        & > .buy-template-dropdown-header {
            font-size: 13px;
        }

        & > .buy-template-copy-disclaimer {
            font-size: 13px;
            color: ${p => p.theme.fgColorMedium};
        }
    }
`;

export const Title = styled.div`
    color: ${p => p.theme.fgColorDark};
    font-weight: 600;
    margin-top: 10px;
`;

export const Author = styled.div`
    color: ${p => p.theme.fgColorMedium};
    font-size: small;
    margin-top: 2px;
`;

export const Disclaimer = styled.div`
    color: ${p => p.theme.fgColorMedium};
    font-size: 80%;
    line-height: 140%;
    margin-top: 20px;
    text-align: center;
    margin-bottom: 16px;
`;
